import { render, staticRenderFns } from "./LoadingButtonContent.vue?vue&type=template&id=6042c7bf"
import script from "./LoadingButtonContent.vue?vue&type=script&lang=js"
export * from "./LoadingButtonContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports